// PastPaper — uploaded past exam paper (parsed to markdown).
//
// Decision (Session 19S):
//   Lives on IngestPackage.pastPapers[] (output of ingest worker after parsing).
//   Bytes (PDF) are stored in IDB pdfs store; this schema only carries
//   parsed content + metadata.
//
//   Multiple past papers allowed — each MockPaperSpec.pastPaperRef points to
//   one by id. Default UI behavior: most-recent-year auto-selected for
//   strict/inspired papers (per陛下 19S decision #2).
import { z } from 'zod';
export const PastPaperSchema = z.object({
    /** Slug; lowercase. e.g. 'past_2024_final', 'past_paper_1'. */
    id: z.string().regex(/^[a-z][a-z0-9_-]*$/, 'past paper id must be lowercase slug'),
    filename: z.string().min(1).max(255),
    /** Parsed markdown content of the past paper. */
    markdown: z.string(),
    /** Optional exam year — drives "default to most recent" UI behavior. */
    year: z.number().int().min(1990).max(2100).optional(),
    /** Optional exam name / variant (e.g. "Final 2024", "Resit 2023"). */
    label: z.string().min(1).max(120).optional(),
    parsedAt: z.string().datetime(),
}).passthrough();
//# sourceMappingURL=past-paper.js.map